<script setup lang="ts">
import { useFilterStore } from '@Portal/stores/filter';
import { storeToRefs } from 'pinia';
import { getImageUrl } from './utility';

interface SocialReviewsGeneratedViewModel {
  count: number;
  title: string;
  matchedReviews: number;
}

const props = defineProps<SocialReviewsGeneratedViewModel>();
const { matchedReviews } = toRefs(props);

const filterStore = useFilterStore();
const { dateFilterDisplayValue } = storeToRefs(filterStore);
</script>

<template>
  <div
    class="stretch-height flex flex-col"
    :style="`background: url(${getImageUrl('/social/ReviewsGeneratedBackground.svg')}); background-position: center; background-size: cover;`"
  >
    <p class="visual-title">Updates {{ dateFilterDisplayValue }}</p>
    <div class="mx-auto my-auto mt-150px flex gap-12px items-center">
      <div class="bg-[#c73362] rounded d-block p-0 px-3 text-white font-bold text-48px line-height-60px">
        {{ matchedReviews }}
      </div>
      <p id="ReviewsGeneratedTagline" class="m-0 text-18px max-w-[210px] font-semibold line-height-24px">
        Reviews Generated from Review Amplifier
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
